<template>
  <section>
    <v-container fluid v-if="session">
      <template v-if="session.session_type_id !== 1 && session.session_type_id !== 2">
        <v-card v-if="session_item">
          <v-toolbar flat dense color="blur"></v-toolbar>
          <v-divider/>
          <v-card-text>
            <v-select label="Tutor"
                      v-model="session_item.tutor_id"
                      :items="available_tutors"
                      color="success"
                      item-text="nickname"
                      item-value="id"
                      item-color="success"
                      outlined
            >
              <template v-slot:item="{item}">
                <v-list-item-action>{{ item.nickname }}</v-list-item-action>
                <v-list-item-content>
                  <div class="" v-html="item.summary"></div>
                </v-list-item-content>
              </template>
            </v-select>

          </v-card-text>
          <v-divider/>
          <v-card-actions class="justify-end">
            <v-btn color="primary" :disabled="!session_item.tutor_id" @click="updateSessionTutor">Update</v-btn>

          </v-card-actions>
        </v-card>
      </template>
      <template v-else>
        Please, use <strong class="text-uppercase">"reschedule"</strong> for change tutor or mock
      </template>

    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    session_item: null,
    available_tutors: [],
  }),
  watch: {
    session: function (val, oldVal) {
      if(oldVal === null) this.boot()
    }
  },
  mounted() {
    if(this.session) this.boot()
  },
  methods: {
    boot() {
      this.session_item = this.session
      this.loadSessionAvailableTutors()
    },
    loadSessionAvailableTutors() {
      this.available_tutors = []
      this.axios.get(`api/sessions/${this.$route.params.session_id}/available-tutors`, {params: {
          mocks:  [this.session_item.mock_id],
          start: this.session_item.start,
          end: this.session_item.end,
        }})
          .then(({data}) => { this.available_tutors = data.data })
          .catch(errors => {
            this.api_errors = errors.response.data.errors
            this.available_tutors = []
          })
    },
    updateSessionTutor() {
      this.app_loading = true
      this.api_errors = []
      this.axios.put(`api/sessions/${this.$route.params.session_id}/update-tutor`, {
        tutor_id: this.session_item.tutor_id
      })
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.$emit('loadSession')
            this.$notify('Success', 'success')
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    }
  }
}
</script>